export default __webpack_public_path__ + "static/media/GR6 2A-2B-1D-1E-2EC.a76329ab.jpg";